<template>
	<goal-settings-content
		widget-type="follower-goal"
		entity-name="follower goal"
		unit="followers"
		@loading="$emit('loading', $event)"
	/>
</template>

<script>
import GoalSettingsContent from '@/components/Widget/GoalSettingsContent.vue';

export default {
	components: { GoalSettingsContent },
};
</script>
